import { z } from '@bonanza-social/toolkit/api';

export const VerifyAddressSchema = z.object({});
